import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { IEnclosure } from '../../../shared/models/enclosure.model';
import { EnclosureTypes } from '../../../enclosure/models/enclosure-type.model';
import { User } from '../../../shared/models/user';
import { DocumentsTypes } from '../../../enclosure/models/documents-types.constants';
import {
  DocumentLoaderKeys,
  IBOMFileModel,
  IDispositionLayoutModel,
  IDocumentLoaderStates
} from '../../../shared/models/document.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-documents-table',
    templateUrl: './documents-table.component.html',
    styleUrls: ['./documents-table.component.scss', '../../../enclosure/scss/documents-table.scss'],
    standalone: false
})
export class DocumentsTableComponent {

  @ViewChild('downloadBOMWithPrice') downloadBOMWithPriceEl: ElementRef;
  @ViewChild('downloadBOMWithPriceXLSX') downloadBOMWithPriceXLSXEl: ElementRef;
  @ViewChild('downloadBOMWithoutPrice') downloadBOMWithoutPriceEl: ElementRef;
  @ViewChild('downloadBOMWithoutPriceXLSX') downloadBOMWithoutPriceXLSXEl: ElementRef;
  @ViewChild('downloadEnclosureLayout') downloadEnclosureLayoutEl: ElementRef;
  @ViewChild('downloadEnclosureLayoutWithCovers') downloadEnclosureLayoutWithCoversEl: ElementRef;
  @ViewChild('downloadDispositionLayoutWithCovers') downloadDispositionLayoutWithCoversEl: ElementRef;
  @ViewChild('downloadDispositionLayout') downloadDispositionLayoutEl: ElementRef;
  @ViewChild('downloadLabelsEl') downloadLabelsEl: ElementRef;
  @ViewChild('downloadLabelsElBackSide') downloadLabelsElBackSide: ElementRef;
  @ViewChild('downloadRatingPlate') downloadRatingPlateEL: ElementRef;
  @ViewChild('downloadRatingPlateXLSX') downloadRatingPlateXLSXEL: ElementRef;
  @ViewChild('downloadSld') downloadSldEL: ElementRef;

  enclosureTypes = EnclosureTypes;
  documentTypes = DocumentsTypes;
  documentLoaderKeys = DocumentLoaderKeys;

  @Input() enclosure: IEnclosure;
  @Input() user: User;
  @Input() selectedDocuments: number[];
  @Input() isProjectDocuments = false;
  @Input() documentLoaderStates: IDocumentLoaderStates;

  @Output() downloadBOMWithPrice = new EventEmitter<IBOMFileModel>();
  @Output() downloadBOMWithoutPrice = new EventEmitter<IBOMFileModel>();
  @Output() downloadBOMWithPriceXLSX = new EventEmitter<IBOMFileModel>();
  @Output() downloadBOMWithoutPriceXLSX = new EventEmitter<IBOMFileModel>();
  @Output() downloadDispositionLayout = new EventEmitter<IDispositionLayoutModel>();
  @Output() downloadRatingPlateWord = new EventEmitter<IBOMFileModel>();
  @Output() downloadSld = new EventEmitter<IBOMFileModel>();
  @Output() downloadRatingPlateWordXLSX = new EventEmitter<IBOMFileModel>();
  @Output() downloadEnclosureLayout = new EventEmitter<IDispositionLayoutModel>();
  @Output() downloadLabels = new EventEmitter<IBOMFileModel>();
  @Output() downloadLabelsBackside = new EventEmitter<IBOMFileModel>();
  @Output() downloadEnclosureLayoutWithCovers = new EventEmitter<IDispositionLayoutModel>();
  @Output() toggleSelectionDocument = new EventEmitter<number>();

  onDownloadBOMWithPrice(title: string) {
    this.downloadBOMWithPrice.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.BOM_WITH_PRICE
    });
  }

  onDownloadBOMWithoutPrice(title: string) {
    this.downloadBOMWithoutPrice.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.BOM_WITHOUT_PRICE
    });
  }

  onDownloadBOMWithPriceXLSX(title: string) {
    this.downloadBOMWithPriceXLSX.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.BOM_WITH_PRICE_XL
    });
  }

  onDownloadBOMWithoutPriceXLSX(title: string) {
    this.downloadBOMWithoutPriceXLSX.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.BOM_WITHOUT_PRICE_XL
    });
  }

  onDownloadDispositionLayout(title: string, showCovers: boolean) {
    this.downloadDispositionLayout.emit({
      title,
      showCovers,
      loaderProperty: showCovers ? DocumentLoaderKeys.DISPOSITION_LAYOUT_WITH_COVER : DocumentLoaderKeys.DISPOSITION_LAYOUT
    });
  }

  onDownloadRatingPlate(title: string) {
    this.downloadRatingPlateWord.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.RATING_PLATE
    });
  }

  onDownloadSld(title: string) {
    this.downloadSld.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.SLD
    });
  }

  onDownloadRatingPlateXLSX(title: string) {
    this.downloadRatingPlateWordXLSX.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.RATING_PLATE_XL
    });
  }

  onDownloadEnclosureLayout(title: string, showCovers: boolean) {
    this.downloadEnclosureLayout.emit({
      title,
      showCovers,
      loaderProperty: DocumentLoaderKeys.ENCLOSURE_LAYOUT
    });
  }

  onDownloadLabels(title: string) {
    this.downloadLabels.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.LABELS
    });
  }

  onDownloadLabelsBackside(title: string) {
    this.downloadLabelsBackside.emit({
      user: this.user,
      fileName: title,
      loaderProperty: DocumentLoaderKeys.LABELS_BACKSIDE
    });
  }

  onDownloadEnclosureLayoutWithCovers(title: string, showCovers) {
    this.downloadEnclosureLayoutWithCovers.emit({
      title,
      showCovers,
      loaderProperty: DocumentLoaderKeys.ENCLOSURE_LAYOUT_WITH_COVER
    });
  }

  onToggleSelectionDocument(id: number) {
    this.toggleSelectionDocument.emit(id);
  }

}
